import { LoginView } from "@/components.auth/login";
export const Login = {
	path:"/auth/login",
	name:"Login",
	component: LoginView,
	meta:{
		title:"Log In",
		public:true
	}
};
